import { isFunction } from "radashi";

export function showSelectPicker(select: HTMLSelectElement) {
  if (isFunction(select.showPicker)) {
    select.showPicker();
  } else {
    // Some browsers need a short delay before dispatching
    setTimeout(() => {
      try {
        select.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
      } catch {
        select.click();
      }
    }, 0);
  }
}
